<template lang="pug">

  
  div(v-if="!authorized")
    v-card.mb-5
      v-card-text
        span Es fehlt dir die Berechtigung, den Inhalt dieser Seite zu sehen.
        
  div(v-else-if="authorized")
  
    v-card.mb-5
      template(v-for="fuer in uniqueRegisterF")
        v-btn(depressed color="primary" v-on:click="registerF = fuer") {{ fuer }}


    v-card.mb-3: v-card-title.headline {{ registerF }} Register 

    v-card.mb-3
        v-card-title Aktueller Ausdruck
        v-card-text
          ol.mt-3.withoutstyletype
            li.mt-4
              strong 1
              ol.withoutstyletype
                li
                  strong Anzahl der bisherigen Eintragungen 
                  br
                  span {{ countEintragungen }}
            template(v-for="head in header" )
              li.mt-4 
                strong {{ head.nummer }} 
                ol.withoutstyletype
                  template(v-for="subs, i in head.updates" ) 
                    li
                      strong  {{ subs.bn }}
                      br
                      template(v-for="up, j in subs.realupdates" )
                        span(v-if="j == subs.realupdates.length - 1" v-html="up.content")
            li.mt-4
              strong {{ maxNumberPlusOne }}
              ol.withoutstyletype
                li
                  strong Tag der letzten Eintragung 
                  br
                  span {{ lastDate }}
        hr   

    v-card.mb-1   
      v-card-title Register Chronologisch
      v-card-text
        table.registertable
          //- HEADERS BEGIN
          tr
            th.registertable__th
              | Nr. der Eintragung
            template(v-for="head in header" )
              th.registertable__th 
                template(v-for="schema in head.columns" )
                  div {{ schema.buchstabeName }}
            //- th.registertable__th
            //-   | Tag der Eintragung   
            th.registertable__th
              | Anhänge     
          tr 
            th.registertable__th
              | 1
            template(v-for="head in header" )
              td.registertable__td 
                strong {{ head.nummer }} 
            th.registertable__th
              | {{ header.length + 2}}  
            //- th.registertable__th
            //-   | {{ header.length + 3}}  
          //- HEADERS END  
          template(v-for="date, c in chronologisch" )
            tr
              td.registertable__td 
                | {{ c + 1 }}
              template(v-for="head in header")
                td.registertable__td
                  template(v-for="ups in head.updates") 
                    span(v-if="ups.realupdates.filter(up => up.tagDerEintragung == date.datum).length > 0") {{ ups.buchstabe }} 
                    template(v-for="up in ups.realupdates")
                      span(v-if="up.tagDerEintragung == date.datum" v-html="up.content" :style="`${up.veraltet ? 'text-decoration: line-through;' : ''}`") 
                      br
              //- td.registertable__td {{ date.datum }}
              td.registertable__td
                template(v-for="head in header")   
                  template(v-for="uds in head.updateDocs") 
                    template(v-for="ud in uds") 
                      template(v-if="ud.tag == date.datum")
                        template(v-for="d in ud.files")
                          a(target="_blank" :href="d.docUrl" ) {{ d.docName }}
                          br 
          
      //- v-card.mb-1   
        //- v-card-title data check
        //- v-card-text {{ header }}

</template>
<style lang="stylus" scoped>
.mystyle 
    font-size: 14px
    font-weight: 600

.registertable
    font-size: 10px
    width: 100%
    border-collapse: collapse
    border-spacing: 0
    .registertable__td
      border: 1px solid grey
      padding: 10px
    .registertable__th
      border: 1px solid grey
      text-align: left
      padding: 10px

.abstand
    margin-left: 30px

.nummerbreite
    width: 30px  

.withoutstyletype
    list-style-type: none      
</style>

<script>
import gql from 'graphql-tag'
import { sortBy, uniq } from 'lodash'
import { user } from '../../router'
import moment from 'moment'

export default {
  props: ['extra'], 
  data(){
    return {
      user,
      registerAll: [],
      registerF: 'HVD BB',
      registerNamen: [],
    }
  },
  apollo: {
    registerAll: {
      query: gql `query ExtraRegisterregisterAll($registerF: String) {
        registerAll: registerSchemes (order: "nummer,buchstabe"  where: { registerFuer: $registerF }) {
              id
              registerFuer
              nummer
              buchstabe
              titelAbsatz
              buchstabeName
              registerUpdates {
                id
                registerSchemeId
                content
                tagDerEintragung
                veraltet
                registerDocuments {
                  id
                  documentUid
                  documentName
                  docUrl
                }
              }
        }
      }`,
      skip() {
        return !this.authorized
      },
      variables(){
        return { registerF: this.registerF }
      }
    },
    registerNamen: {
      query: gql `query ExtraRegisterRegisterNamen {
        registerNamen: registerSchemes {
          registerFuer
        }
      }`,
      skip() {
        return !this.authorized
      }
    }
  },
  computed: {
    authorized() {
      return this.user && (this.user.roles.indexOf('register_read') > -1 || this.user.roles.indexOf('admin') > -1)
    },
    uniqueDates(){
      let daten = []
      this.registerAll.forEach(register => {
        register.registerUpdates.forEach(updates => {
          daten.push(updates.tagDerEintragung)
        })
      })
      daten = uniq(daten).sort()
      return daten
    },
    uniqueRegisterF(){
      let daten = []
      this.registerNamen.forEach(regi => {
        daten.push(regi.registerFuer)
      })
      daten = uniq(daten)
      return daten
    },
    countEintragungen() {
      return this.uniqueDates.length
    },
    maxNumberPlusOne() {
      let mnpo = 0
      this.registerAll.forEach(register => {
        if (register.nummer >= mnpo) {
          mnpo = register.nummer + 1
        }
        })
      return mnpo
    },
    lastDate(){
      var lastone = moment(this.uniqueDates[this.uniqueDates.length-1])
      return lastone.format('DD.MM.Y')
    },
    chronologisch() {
      return this.uniqueDates.map( datum => {
        return {
          datum
        }
      })    
    },
    header() {
      let header = []
      this.registerAll.forEach(register => {
        header.push(register.nummer)
      })
      header = uniq(header).sort()
      return header.map( nummer => {
        return { 
          nummer, 
          columns: this.registerAll.filter( reg => reg.nummer === nummer),
          updates: this.registerAll.filter( reg => reg.nummer === nummer).map( regi => {
            return {
              buchstabe: regi.buchstabe,
              bn: regi.buchstabe + " " + regi.titelAbsatz,
              realupdates: sortBy(regi.registerUpdates, 'tagDerEintragung')
            }
          }),
          updateDocs: this.registerAll.filter( reg => reg.nummer === nummer).map( regi => { 
            return regi.registerUpdates.map( oneupdate => {
              return {
                tag: oneupdate.tagDerEintragung,
                files: oneupdate.registerDocuments.map(onedoc =>{
                  return{
                    docName: onedoc.documentName,
                    docUrl: onedoc.docUrl
                  }
                })
              }
            })
          })
        }
      })
    }
  }
}
</script>